import React from 'react';

const AcademiaSectionWrapper = ({
  sectionTitle,
  children,
  additionalClassName,
}: {
  sectionTitle: string;
  children: React.ReactNode;
  additionalClassName?: string;
}) => {
  // rendering associate section wrapper component here
  return (
    <div
      className={`relative border-2 border-legal-dark-blue border-dashed py-7 px-3 md:px-5 md:py-5 rounded-xl mt-10 ${additionalClassName}`}
    >
      <h3 className='absolute -top-[35px] translate-y-1/2 text-2xl bg-base-white px-2 text-legal-dark-blue italic capitalize'>
        {sectionTitle}
      </h3>
      {children}
    </div>
  );
};

export default AcademiaSectionWrapper;
